import { toQuery } from 'src/utils/utils';

import { handleResponse } from '../utils/auth-header';
import axios, { axiosOption } from '../utils/axios';

export const NewdanhmuckhachhangService = {

  khachhangList: () => {
    return axios.post('/api/v1/newdanhmuckhachhang/khachhangList', {}, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  homepageList: (payload) => {
		return axios.post(`/api/v1/newdanhmuckhachhang/homepageList`, payload, axiosOption()).then((rs) => {
			return handleResponse(rs)
		}).catch((error) => {
			throw handleResponse(error.response)
		})
	},

	homepageFindOne: (id) => {
		return axios.get(`/api/v1/newdanhmuckhachhang/homepageFindOne/${id}`, axiosOption()).then((rs) => {
			return handleResponse(rs)
		}).catch((error) => {
			throw handleResponse(error.response)
		})
	},
	
	sendOrder: (payload) => {
		return axios.post('/api/v1/newdanhmuckhachhang/sendOrder', payload, axiosOption()).then((rs) => {
			return handleResponse(rs)
		}).catch((error) => {
			throw handleResponse(error.response)
		})
	},
	
	create: (payload) => {
    return axios.post('/api/v1/newdanhmuckhachhang', payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  save: (payload) => {
    return axios.post('/api/v1/newdanhmuckhachhang/import', payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  update: (id, payload) => {
    return axios.put(`/api/v1/newdanhmuckhachhang/${id}`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  findAll: (page, count, payload) => {
    let url = `/api/v1/newdanhmuckhachhang?page=${page}&count=${count}`;

    if (payload.ma) {
        url += `&ma=${payload.ma}`
    };

    if (payload.ten) {
        url += `&ten=${payload.ten}`
    };

    if (payload.doi_tuong) {
        url += `&doi_tuong=${payload.doi_tuong}`
    };
    
    return axios.get(url, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  listExport: (payload) => {
    let url = `/api/v1/newdanhmuckhachhang?page=${payload.page}&count=${payload.limit}`;

    if (payload.ma) {
        url += `&ma=${payload.ma}`
    };

    if (payload.ten) {
        url += `&ten=${payload.ten}`
    };

    if (payload.doi_tuong) {
        url += `&doi_tuong=${payload.doi_tuong}`
    };
    
    return axios.get(url, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  findAssign: (page, count) => {
    return axios.get(`/api/v1/newdanhmuckhachhang/assign?page=${page}&count=${count}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  find: (id) => {
    return axios.get(`/api/v1/newdanhmuckhachhang/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  findPackage: (ten_goi_cuoc) => {
    return axios.get(`/api/v1/newdanhmuckhachhang/findPackage/${ten_goi_cuoc}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  countAssign: () => {
    return axios.get(`/api/v1/newdanhmuckhachhang/count-assign`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  delete: (id) => {
    return axios.delete(`/api/v1/newdanhmuckhachhang/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  assign: (payload) => {
    return axios.post(`/api/v1/newdanhmuckhachhang/assign`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  history: (payload) => {
    return axios.get(`/api/v1/care/history?${toQuery(payload)}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  listNoLimit: () => {
    return axios.get(`/api/v1/newdanhmuckhachhang/listNoLimit`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  getSimAnalysis: (number) => {
    return axios.get(`/api/v1/newdanhmuckhachhang/getSimAnalysis/${number}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },
}